import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import HomeIcon from "@mui/icons-material/Home";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Meta } from "@/shared/components";
import { PagePaths } from "@/partner/shared/constants";

export const NotFoundPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleGoHome = () => {
    navigate(PagePaths.partner);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <>
      <Meta title={t("notFound.pageTitle")} pageType="Partner" />

      <Container maxWidth="md">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "70vh",
            textAlign: "center",
            py: 4,
          }}
        >
          {/* Большая цифра 404 */}
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "6rem", sm: "8rem", md: "10rem" },
              fontWeight: "bold",
              color: "primary.main",
              lineHeight: 0.9,
              mb: 2,
              background: "linear-gradient(45deg, #1976d2, #42a5f5)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            404
          </Typography>

          {/* Заголовок */}
          <Typography
            variant="h4"
            component="h1"
            sx={{
              mb: 2,
              fontWeight: 600,
              color: "text.primary",
              fontSize: { xs: "1.5rem", sm: "2rem" },
            }}
          >
            {t("notFound.title")}
          </Typography>

          {/* Описание */}
          <Typography
            variant="body1"
            sx={{
              mb: 4,
              color: "text.secondary",
              maxWidth: "500px",
              fontSize: { xs: "1rem", sm: "1.1rem" },
              lineHeight: 1.6,
            }}
          >
            {t("notFound.description")}
          </Typography>

          {/* Кнопки */}
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            sx={{ mt: 2 }}
          >
            <Button
              variant="contained"
              size="large"
              startIcon={<HomeIcon />}
              onClick={handleGoHome}
              sx={{
                px: 4,
                py: 1.5,
                borderRadius: 2,
                fontSize: "1.1rem",
              }}
            >
              {t("notFound.goHome")}
            </Button>

            <Button
              variant="outlined"
              size="large"
              startIcon={<ArrowBackIcon />}
              onClick={handleGoBack}
              sx={{
                px: 4,
                py: 1.5,
                borderRadius: 2,
                fontSize: "1.1rem",
              }}
            >
              {t("notFound.goBack")}
            </Button>
          </Stack>

          {/* Декоративные элементы */}
          <Box
            sx={{
              position: "absolute",
              top: "20%",
              left: "10%",
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              background: "linear-gradient(45deg, #e3f2fd, #bbdefb)",
              opacity: 0.3,
              display: { xs: "none", md: "block" },
            }}
          />

          <Box
            sx={{
              position: "absolute",
              top: "60%",
              right: "15%",
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              background: "linear-gradient(45deg, #f3e5f5, #e1bee7)",
              opacity: 0.3,
              display: { xs: "none", md: "block" },
            }}
          />
        </Box>
      </Container>
    </>
  );
};
